import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container, Alert, Button } from 'react-bootstrap';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminRoute from './components/auth/AdminRoute';
import Navigation from './components/common/Navigation';
import Footer from './components/common/footer';
import Login from './components/auth/Login';
import LeadList from './components/leads/LeadList';
import LeadForm from './components/leads/LeadForm';
import LeadDetail from './components/leads/LeadDetail';
import AgentProfile from './components/agents/AgentProfile';
import AdminDashboard from './components/admin/AdminDashboard';
import LeadManagement from './components/admin/LeadManagement';
import AgentManagement from './components/admin/AgentManagement';
import AdminLeadDetail from './components/admin/AdminLeadDetail';
import CreateAgent from './components/admin/CreateAgent';
import Roles from './components/admin/Roles';
import Teams from './components/admin/Teams';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';
import './styles/AdminDashboard.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Navigation />
          <div className='body-content'>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />

              {/* Agent Routes */}
              <Route path="/leads" element={
                <PrivateRoute>
                  <LeadList />
                </PrivateRoute>
              } />
              <Route path="/add-lead" element={
                <PrivateRoute>
                  <LeadForm />
                </PrivateRoute>
              } />
              <Route path="/lead/:leadId" element={
                <PrivateRoute>
                  <LeadDetail />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <AgentProfile />
                </PrivateRoute>
              } />

              {/* Admin Routes */}
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
              <Route path="/admin/leads" element={
                <AdminRoute>
                  <LeadManagement />
                </AdminRoute>
              } />
              <Route path="/admin/agents" element={
                <AdminRoute>
                  <AgentManagement />
                </AdminRoute>
              } />
              <Route path="/admin/create-agent" element={
                <AdminRoute>
                  <CreateAgent />
                </AdminRoute>
              } />
              <Route path="/admin/roles" element={
                <AdminRoute>
                  <Roles />
                </AdminRoute>
              } />
              <Route path="/admin/teams" element={
                <AdminRoute>
                  <Teams />
                </AdminRoute>
              } />
              {/* FIXED: Admin lead detail route */}
              <Route path="/admin/leads/:leadId" element={
                <AdminRoute>
                  <AdminLeadDetail />
                </AdminRoute>
              } />

              {/* Default Route */}
              <Route path="/" element={<Navigate to="/leads" />} />

              {/* FIXED: 404 Route with proper fallback */}
              <Route path="*" element={
                <Container className="mt-5 text-center">
                  <Alert variant="danger" className="mt-5">
                    <Alert.Heading>Page Not Found</Alert.Heading>
                    <p>The page you're looking for doesn't exist.</p>
                    <div className="d-flex justify-content-center gap-3 mt-3">
                      <Button variant="outline-primary" onClick={() => window.location.href = '/leads'}>
                        Go to Agent Dashboard
                      </Button>
                      <Button variant="outline-secondary" onClick={() => window.location.href = '/admin'}>
                        Go to Admin Dashboard
                      </Button>
                    </div>
                  </Alert>
                </Container>
              } />
            </Routes>
          </div>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;